import type { IDEToolingRow } from '../../devenvbootstrap/framework';

type Props = { items?: IDEToolingRow[] };

export function IDEToolingPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.tool} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.tool}</p>
            <p className="font-mono text-xs text-brand-600">{item.config}</p>
          </div>
          <p className="mt-1 text-xs text-slate-500">{item.description}</p>
        </div>
      ))}
    </div>
  );
}
